import {
  BookerCommissionsHistogramOutput,
  GetBookerCommissionsHistogramInput,
} from '@allocab/allocab-passenger-shared-types';
import { useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';

import { queryKeys } from '../services/datastore/queryKeys';
import { DEFAULT_CACHE_TIME, queryClient } from '../services/datastore/react-query';
import { passengerApi } from '../services/network/Api';

const fetchBookerCommissions = (input?: GetBookerCommissionsHistogramInput) =>
  passengerApi.get<unknown, BookerCommissionsHistogramOutput>('/account/v1/booker-commissions', input);

export const useFetchBookerCommissions = (input: GetBookerCommissionsHistogramInput = {}) =>
  useQuery(queryKeys.user.fetchBookerCommissions(input), () => fetchBookerCommissions(input), {
    staleTime: DEFAULT_CACHE_TIME,
  });

export const usePrefetchBookerCommissions = () => {
  useEffect(() => {
    queryClient.prefetchQuery(queryKeys.user.fetchBookerCommissions(), () => fetchBookerCommissions());
  }, []);
};
